module.exports = __webpack_public_path__ + "img/pptx.a43fbe5e.svg";